<template>
  <resource-list-layout :resourceTitle="title">
    <template v-slot:operation>
      <el-button slot="append" type="primary" size="mini" @click="loadTask">创建导出任务</el-button>
    </template>
    <resource-list-page-content :pageData="pageData" :cols="cols" v-loading="loading" :showActionColumn="true">
      <template v-slot:action="scope">
        <el-button type="text" size="medium" @click="loadFile(scope.scope.$index, scope.scope.row)">下载</el-button>
      </template>
    </resource-list-page-content>
  </resource-list-layout>
</template>

<script>
import ResourceListLayout from 'common/ResourceListLayout'
import ResourceListPageContent from 'common/ResourceListPageContent'
export default {
  name: 'ExportTasks',
  components: {
    ResourceListLayout,
    ResourceListPageContent
  },
  computed: {
  },
  watch: {
    'pageOption.currentPage': {
      handler (newVal) {
        this.fetchData()
      }
    },
    'pageOption.pageSize': {
      handler (newVal) {
        this.fetchData()
      }
    }
  },
  data () {
    return {
      title: '导出任务',
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1,
        pageSize: 30, // 每页显示条数
      },
      loading: false,
      cols: [
        { label: '任务编号', prop: 'task_code' },
        { label: '文件名', prop: 'file_name' },
        { label: '创建时间', prop: 'created_at' }
      ],
      file: null
    }
  },
  provide () {
    return {
      pageOption: this.pageOption
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.$axios.get('/api/admin/export_tasks?page=' + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.pageData = data.data.data
            this.pageOption.total = data.data.total
            this.loading = false
          }
        })
    },
    loadTask () {
      this.$axios.post('/api/admin/tasks/export/companies', { ids: '1,2,3,4,5,6' }, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success('ok');
            this.fetchData()
          }
        })
    },
    loadFile (index, row) {
      let url = 'https://qyhoss.oss-cn-hangzhou.aliyuncs.com/' + row.file_path
      // 创建一个隐藏的链接元素
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', ''); // 设置 download 属性

      // 将链接元素添加到文档中并触发点击事件
      document.body.appendChild(link);
      link.click();

      // 移除链接元素
      document.body.removeChild(link);
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/export_tasks/ExportTasks.vue